import type { BoggleGameModeDefinition } from '~/boggle/gameModes/types'
import { BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS } from '~/boggle/gameModes/challengeAllowedBonuses'
import { RACE_CHALLENGE_CORE_DEFINITIONS } from '../race/cores'
import { REBOOT_CORE_PRESET } from './preset'
import { RebootHowToPlay } from './howToPlay'

export const REBOOT_GAME_MODE: BoggleGameModeDefinition = {
  challenge: {
    allowedBonusIds: BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS,
    buttonLabel: 'Challenge',
    coreDefinitions: RACE_CHALLENGE_CORE_DEFINITIONS,
    practiceOverrides: {
      intervalCount: 1,
      intervalTimeSeconds: 30,
    },
  },
  color: '#d6a44b',
  corePreset: REBOOT_CORE_PRESET,
  howToPlay: <RebootHowToPlay />,
  id: 'reboot',
  name: 'Reboot',
  tagline: 'Clear the board, then do it again.',
}
